import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../client';

export interface Invitation {
  id: number;
  email: string;
  role_names: string[];
  client_id: number | null;
  expires_at: number;
  consumed_at: number | null;
  created_at: number;
  invited_by_name: string | null;
  client_name: string | null;
}

export function useInvitations() {
  return useQuery({
    queryKey: ['invitations'],
    queryFn: ({ signal }) =>
      api.get<{ invitations: Invitation[] }>('/api/invitations', signal),
  });
}

export interface CreateInvitationInput {
  email: string;
  role_names: string[];
  client_id?: number;
}

export function useCreateInvitation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateInvitationInput) =>
      api.post<{
        invitation_id: number;
        expires_at: number;
        email_sent: boolean;
        email_stubbed: boolean;
        invite_token: string;
      }>('/api/invitations', input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['invitations'] });
    },
  });
}

export function useRevokeInvitation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.delete<void>(`/api/invitations/${id}`),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['invitations'] });
    },
  });
}

export interface ConsumeInvitationInput {
  token: string;
  password: string;
  display_name: string;
}

export function useConsumeInvitation() {
  return useMutation({
    mutationFn: (input: ConsumeInvitationInput) =>
      api.post<{ user_id: number }>('/api/invitations/consume', input),
  });
}
